export const ColorActionValues = {
  NA: 0,
  GREEN: 1,
  YELLOW: 2,
  RED: 3
};

export const ColorActionLabels = {
  [ColorActionValues.NA]: 'NA',
  [ColorActionValues.GREEN]: 'Green- Good',
  [ColorActionValues.YELLOW]: 'Yellow- Needs An Action',
  [ColorActionValues.RED]: 'Red- You are behind schedule!'
};
